import { useState, useEffect } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetailParams } from "../../state/itemGroupEntrySlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";



const CreateItemGroupEntry = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    const [submitBtnId, setSubmitBtnId] = useState("")
    const { detailParams, isNewEntry } = useSelector((state) => state.itemGroupEntry);

    const [formData, setFormData] = useState({
        itgrCode: "",
        itgrName: "",
        stPer: 0,
        astPer: 0,
        cstPer: 0
    });

    const { data: detail = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.itemGroup.fetchEntryDetail,
        queryKey: "fetchItemGroupdetail",
    });

    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {

            filterDetail({
                data: {
                    itgr_code: detailParams.itgr_code
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && detail && detail.length > 0) {
            setFormData({
                itgrCode: detail[0].Itgr_Code || "",
                itgrName: detail[0].Itgr_Name || "",
                stPer: detail[0].StPer || 0,
                astPer: detail[0].AstPer || 0,
                cstPer: detail[0].CstPer || 0,
            });
            // console.log(shapeDetails.S_Code, isNewEntry, formData)

        }
    }, [detail]);



    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const { mutate: funAddUpdate, isPending, isError } = usePost({
        queryKey: "ItgrGroupAddUpdate",
        url: apiRoute.itemGroup.add_update,
        onSuccessTasks: () => {
            dispatch(resetDetailParams());
            if (submitBtnId == 'btnSaveNew') {
                setFormData({
                    itgrCode: "",
                    itgrName: "",
                    stPer: 0,
                    astPer: 0,
                    cstPer: 0
                })
            }
            else
                navigate(linksUrl.master.itemGroup.itemGroupMaster);
        },
    });

    // const onSuccessChkDupCode = (data) => {
    //     let isDuplicate = 0
    //     if (isNewEntry && data && data.length > 0) {

    //         if (data[0].count > 0) {
    //             if (!toast.isActive("toast_chkshpid")) {
    //                 toast.error(`Duplicate Shape Code Found`, {
    //                     "position": "top-center",
    //                     "className": "toast-error",
    //                     toastId: "toast_chkcshpid"
    //                 })
    //             }
    //             isDuplicate = 1
    //         }
    //     }
    //     if (isDuplicate === 0) {
    //         addUpdateShape({
    //             data: {
    //                 ...formData,
    //                 UID: user.username,
    //                 pRecStatus: 2,
    //             }
    //         });

    //     }
    // }
    const { mutate: funChkDupItgrCode } = usePost({
        queryKey: "checkItgrCode",
        url: apiRoute.itemGroup.checkItgrCode,
        onSuccessTasks: (data) => {
            console.log(data)
            if (data && data.length > 0) {
                if (!toast.isActive("toast_chkcitgrid")) {
                    toast.error(`Item Group Code Exist Enter Another Code`, {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_chkcitgrid"
                    })
                }
                setFormData({ ...formData, itgrCode: "" })
            }

        }
    });

    const handleBlur = (e) => {
        const { name, value } = e.target;

        funChkDupItgrCode({
            data: {
                itgr_code: value
            }
        })

    }
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
        funAddUpdate({
            data: {
                ...formData,
                login_userid: user.username,
                rec_status: !isNewEntry ? 1 : 2,
            }
        });

    };



    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <MainContainer
            pageName="Item Group Entry"
            breadcrumbs={["Master", "Item Group Entry"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.master.itemGroup.itemGroupMaster) }}
        >
            {/* <Card className="p-6"> */}
            <Card shadow="sm" radius="sm" className="mb-3  h-[calc(100vh-118px)]  overflow-y-auto">

                <form onSubmit={handleSubmit}>
                    <CardBody>
                        <div className="grid gap-4">
                            <Input label="Group Code" variant="bordered" type="text"
                                className="text-slate-700" size="sm" readOnly={isNewEntry ? false : true} name="itgrCode"
                                value={formData.itgrCode} onChange={handleChange}
                                onBlur={handleBlur}
                                isRequired />
                            <Input label="Group Name" variant="bordered" className="font-semibold text-slate-700" size="sm" name="itgrName" value={formData.itgrName} onChange={handleChange} isRequired />
                            <Input label="St Per" variant="bordered"
                                className=" text-slate-700" size="sm"
                                type="number" name="stPer" value={formData.stPer} onChange={handleChange} />
                            <Input label="Ast Per" variant="bordered" className="font-semibold text-slate-700" size="sm" type="number" name="astPer" value={formData.astPer} onChange={handleChange} />
                            <Input label="Cst Per" variant="bordered" classNames="font-semibold text-slate-700" size="sm" type="number" name="cstPer" value={formData.cstPer} onChange={handleChange} />
                            <div className="flex gap-4 items-center justify-center">
                                <Button type="submit" id="btnSave" color="primary" size="sm" isLoading={isPending}>
                                    {isNewEntry ? "Save" : "Update"}
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                <Button size="sm" onPress={() => navigate(linksUrl.master.itemGroup.itemGroupMaster)} color="danger" isLoading={isPending}>
                                    Cancle
                                </Button>
                            </div>
                        </div>
                    </CardBody>
                </form>




            </Card>
        </MainContainer>
    );
};

export default CreateItemGroupEntry;

